export default "/images/813a3ffba1c9bf0f0c42d411aa81d3fa.avif";